import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, Field } from 'redux-form';
import { Translate } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './LocationPreview.styles';
import { LocationValidations } from '../../../../models';
import {
  LOCATION_TYPES,
  GEO_REFERENCE_TYPES
} from '../../../../constants/areas';

import Button from '../../../inputs/button/Button';
import AddForm from '../../addform/AddForm';
import FormActions from '../../formactions/FormActions';
import MapGLInput from '../../../inputs/mapglinput/MapGLInput';

export class LocationPreview extends Component {
  render() {
    if (!this.props.area) {
      return false;
    }
    let { nwCorner, seCorner } = this.props.area.indoorMapping;
    let polygon = this.props.zone && this.props.zone.polygon;
    let file =
      this.props.area.file &&
      !!this.props.area.file.length &&
      this.props.area.file[0].preview;
    let showMap =
      this.props.area.location === LOCATION_TYPES.OUTDOOR ||
      this.props.area.geoReferenced === GEO_REFERENCE_TYPES.YES;
    return (
      <AddForm onSubmit={this.props.handleSubmit} styles={styles.form}>
        <Translate className={css(styles.title)} value="add.location.drawing" />
        <Field
          name="point"
          type="point"
          showMap={showMap}
          validate={LocationValidations.point}
          component={MapGLInput}
          props={{
            nwCorner,
            seCorner,
            file,
            polygon,
            areaPolygon: this.props.area.polygon,
            options: {
              ...(showMap
                ? {}
                : {
                    zoom: 12,
                    minZoom: 10,
                    maxZoom: 14
                  })
            }
          }}
        />
        <FormActions>
          <Button>
            {this.props.isEditing ? (
              <Translate value="edit.edit" />
            ) : (
              <Translate value="add.add" />
            )}
          </Button>
        </FormActions>
      </AddForm>
    );
  }
}

const selector = formValueSelector('addlocation');
const mapStateToProps = state => {
  return { ...selector(state, 'area', 'zone') };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'addlocation',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })(LocationPreview)
);



// WEBPACK FOOTER //
// ./src/components/forms/addlocationform/locationpreview/LocationPreview.js